// extracted by mini-css-extract-plugin
export default {"hed":"mm","blend":"nm","resultsBox":"om","left":"pm","right":"qm","center":"rm","base":"sm","milk":"tm","text":"um","hyroxresult":"vm","margin":"wm"};
    if(module.hot) {
      // 1715091668851
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  